module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-4-photo-12-053777917ac050c4dea87082dfbb6a72.webp";